import { createServerFn } from "@tanstack/react-start";
import { getRequestHeader, getRequestIP } from "@tanstack/react-start/server";
import { z } from "zod";

const scheduleSchema = z.object({
  event_id: z.string().trim().min(4).max(120),
  email: z.string().trim().email().max(255).nullable().optional(),
  phone: z.string().trim().max(40).nullable().optional(),
  first_name: z.string().trim().max(100).nullable().optional(),
  last_name: z.string().trim().max(100).nullable().optional(),
  fbp: z.string().trim().max(200).nullable().optional(),
  fbc: z.string().trim().max(500).nullable().optional(),
  page_url: z.string().trim().max(1000).nullable().optional(),
  tier: z.string().trim().max(10).nullable().optional(),
  outcome: z.string().trim().max(60).nullable().optional(),
});

/**
 * Server-side Meta "Schedule" event, fired when a call is booked on the
 * calendar embed. Uses the same event_id as the browser pixel fire so Meta
 * dedupes the two into a single conversion.
 */
export const trackScheduleConversion = createServerFn({ method: "POST" })
  .inputValidator((input) => scheduleSchema.parse(input))
  .handler(async ({ data }) => {
    const { sendMetaCapiEvent } = await import("./meta-capi.server");
    let ip: string | null = null;
    try {
      ip = getRequestIP({ xForwardedFor: true }) ?? null;
    } catch {
      ip = null;
    }
    const result = await sendMetaCapiEvent({
      eventName: "Schedule",
      eventId: data.event_id,
      eventSourceUrl: data.page_url ?? null,
      user: {
        email: data.email ?? null,
        phone: data.phone ?? null,
        firstName: data.first_name ?? null,
        lastName: data.last_name ?? null,
        fbp: data.fbp ?? null,
        fbc: data.fbc ?? null,
        clientIp: ip,
        userAgent: getRequestHeader("user-agent") ?? null,
      },
      customData: {
        lead_tier: data.tier ?? undefined,
        routing_outcome: data.outcome ?? undefined,
      },
    });
    return { ok: result.ok, error: result.error ?? null };
  });
